import styled from 'styled-components';
import { rem } from 'polished';
import DayMonth from '../DayMonth';
import DayNumber from '../DayMonth/DayNumber';
import Month from '../DayMonth/Month';
import DayText from '../DayMonth/DayText';

const StyledCalendarEventDate = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.gray};
  color: ${props => props.theme.colors.dark};
  display: flex;
  height: auto;
  justify-content: space-between;
  padding: ${rem('20px')} ${rem('5px')} ${rem('20px')} ${rem('16px')};
`;

const StyledDateDayMonth = styled(DayMonth)`
  color: ${props => props.theme.colors.dark};
  display: flex;
`;

// Ya esta float y solo en menor de desktop es none
const StyledDayNumber = styled(DayNumber)`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  display: none;
  margin: ${rem('-1px')} ${rem('5px')} 0 0;
`;

const StyledDayNumberNoDesktop = styled(StyledDayNumber)`
  display: block;
`;

const StyledDateRight = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  padding-bottom: ${rem('0px')};
`;

const StyledMonth = styled(Month)`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.medium};
`;

const StyledDayText = styled(DayText)`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.medium};
  padding-right: ${rem('5px')};
`;

export {
  StyledCalendarEventDate,
  StyledDateDayMonth,
  StyledDayNumber,
  StyledMonth,
  StyledDayText,
  StyledDateRight,
  StyledDayNumberNoDesktop
};
